import * as React from 'react';
import { useSelector, useStore } from 'react-redux';
import c from 'classnames';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import commentsStyles from '../../css/_comments.css';
import {
  selectWideComments,
  changeWideCommentsAction,
  selectDefaultSort,
  selectCommentsUnderVideo,
  selectKachingInitialized, selectItemUploadId, selectItemIsLoaded,
} from '../../ducks';
import { documentSetCookie } from '../../cookie';
import { CommentsApp } from 'comments';
import { settings } from '../../settings';
import { Loading } from '../loading';
import { Notification } from '../notification';
import { Sorting } from './';
import { icons } from './icons';
import { ClickElement } from '../form';
import { userLogout } from '../../apis/user';
import { 
  useItemViewSearchParams, 
  useShowingOnScroll, 
  useMounted, 
  ThemeContext,
} from '../commons';

const ChangeCommentWidth = () => {
  const { dispatch } = useStore();
  const isWideComments = useSelector(selectWideComments);
  const underVideo = useSelector(selectCommentsUnderVideo);
  const iconDirection = () => {
    if (isWideComments && !underVideo ||!isWideComments && underVideo) { return 'right' ; }
    if (isWideComments && underVideo || !isWideComments && !underVideo) { return 'left' ; }
  };
  return (
    <div className={'change-comment-width'} onClick={() => {
      documentSetCookie('wideComments', !isWideComments);
      dispatch(changeWideCommentsAction(!isWideComments));
    }}>
      <FontAwesomeIcon icon={`angle-double-${iconDirection()}`} size="lg" />
    </div>
  );
};

export const Comments = ({ itemId, currentBreakPoint, showTwitchChat }) => {
  const showing = useShowingOnScroll();
  const defaultSorting = useSelector(selectDefaultSort);
  const { selectedId } = useItemViewSearchParams();
  const adsInitialized = useSelector(selectKachingInitialized);
  const hasItemId = itemId !== undefined;
  const uploadId = useSelector(selectItemUploadId);
  const itemIsLoaded = useSelector(selectItemIsLoaded);
  const isMounted = useMounted();

  return(
    <ThemeContext.Consumer>
      {({ isNightMode }) => (
        <div className={c(
          commentsStyles['comments-wrapper'],
          {[commentsStyles['nightmode']]: isNightMode },
          {[commentsStyles['twitch-chat']]: showTwitchChat },
        )}>
          {(showTwitchChat && !isMounted) && (
            <div style={{ 
              height: '100%', 
              width: '100%', 
              display: 'flex', 
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <Loading smallLoader showSuffix={false}/>
            </div>
          )}          
          {(showTwitchChat && isMounted) && (
            <iframe id="twitch-chat-embed"
              src={`https://www.twitch.tv/embed/dumpert/chat?parent=${window.location.hostname}`}
              height="100%"
              width="100%">
            </iframe>
          )}
          {!showTwitchChat && (
            <CommentsApp
              userHost={settings.USER_HOST}
              commentsHost={settings.COMMENTS_HOST}
              adminHost={settings.ADMIN_HOST}
              commentsStyles={commentsStyles}
              uploadId={itemIsLoaded && !uploadId ? -1 : uploadId}
              postId={itemId}
              articleId={hasItemId ? itemId.split('_')[0] : null} //PRODUCTION
              crc={hasItemId ? itemId.split('_')[1] : null} //PRODUCTION
              defaultSorting={defaultSorting}
              showingOnScroll={selectedId ? true : showing}
              siteConfig={{
                kudosEnabled: true,
                defaultSort: defaultSorting,
                availableSorts: [
                  'mostKudosFirst',
                  'newestFirst',
                  'oldestFirst',
                  'moderatorView',
                ],
              }}
              icons={icons}
              currentBreakPoint={currentBreakPoint}
              sortingComponent={Sorting}
              loadingComponent={Loading}
              FontAwesomeComponent={FontAwesomeIcon}
              linkComponent={Link}
              notificationComponent={Notification}
              changeCommentWidthComponent={ChangeCommentWidth}
              clickElementComponent={ClickElement}
              isNightMode={isNightMode}
              adsInitialized={adsInitialized}
              userLogout={userLogout}
            
            //premiumEnabled
            />
          )}
        </div>
      )}
    </ThemeContext.Consumer>
  );
};
